import type { ReturnRequestStatusDto } from "@babackapp/private-api-client";
import { TruckIcon } from "@heroicons/react/24/solid";
import { PackageCheck, PackageX } from "lucide-react";
import type { ReactNode } from "react";

export type AlertConfig = {
  variant: "default" | "destructive" | "pending" | "info";
  icon: ReactNode;
  titleKey: string;
  descriptionKey: string;
};

export function resolveAlertConfig(status: ReturnRequestStatusDto): AlertConfig | null {
  if (status.cancelled.done) {
    return { variant: "destructive", icon: <PackageX />, titleKey: "returnRequests.details.timeline.cancelled", descriptionKey: "returnRequests.details.status.cancelled.description" };
  }
  if (status.resolved.done) {
    return { variant: "default", icon: <PackageCheck />, titleKey: "returnRequests.details.timeline.resolved", descriptionKey: "returnRequests.details.status.resolved.description" };
  }
  if (
    status.treatedMerchant.done ||
    status.treatedLogistician.done ||
    status.partiallyTreatedMerchant.done ||
    status.partiallyTreatedLogistician.done
  ) {
    return { variant: "info", icon: <PackageCheck />, titleKey: "returnRequests.details.status.treated.title", descriptionKey: "returnRequests.details.status.treated.description" };
  }
  if (status.shipped.done) {
    return { variant: "info", icon: <TruckIcon />, titleKey: "returnRequests.details.timeline.shipped", descriptionKey: "returnRequests.details.status.shipped.description" };
  }
  if (status.shipping.done) {
    return { variant: "pending", icon: <TruckIcon />, titleKey: "returnRequests.details.timeline.shipping", descriptionKey: "returnRequests.details.status.approved.description" };
  }
  if (status.approved.done) {
    return { variant: "pending", icon: <TruckIcon />, titleKey: "returnRequests.details.timeline.approved", descriptionKey: "returnRequests.details.status.approved.description" };
  }
  if (status.waiting.done) {
    return { variant: "pending", icon: <TruckIcon />, titleKey: "returnRequests.details.timeline.waiting", descriptionKey: "returnRequests.details.status.waiting.description" };
  }
  return null;
}
